import { JBaseApi } from '../base';
import { ApiWrapper, FormatList, jObjectLittle } from '../../types';
import { OF } from '../../util';

export class JBusinessNetworkingApi extends JBaseApi {
    getInfos<T extends jObjectLittle = jObjectLittle>(id: number, format?: FormatList): Promise<ApiWrapper<T>> {
        return this.network.post({
            o: 'BusinessNetworking',
            f: 'MarkerInfo',
            id,
            format: format ?? 'raw-little',
        } as OF);
    }
}
